module.exports = __webpack_public_path__ + "static/Poppins-SemiBold-4cdacb8f89d588d69e8570edcbe49507.ttf";